import { useMemo } from "react";

import { DataTable } from "@/components/DataTable";
import { getSosEntityHashId } from "@/components/SosEntityHashLink";
import { TableWrapper } from "@/components/TableWrapper";
import { CostTaxBreakdown } from "../../queries/tracking-data/cost-tax-breakdown";
import { withJobTrackingData } from "../withJobTrackingData";
import { usePurchasingNotesByItemId } from "../purchasing-progress/usePurchasingNotesByItemId";
import { existingInventoryTableColumns, ExistingInventoryTableRow } from "./existing-inventory-table-columns";

export const ExistingInventory = withJobTrackingData(({ existingInventory, bomComponentsByItemId, job }) => {
  // Fetch all purchasing notes for the current job
  const notesByItemIdQuery = usePurchasingNotesByItemId(job.id);

  // Flatten the list of shipments into a list of table rows (one row for each line item)
  const data = useMemo(
    () =>
      existingInventory.map<ExistingInventoryTableRow>((x) => {
        const bomComponent = bomComponentsByItemId.get(x.item.id);

        return {
          ...x,
          rowId: getSosEntityHashId("item", x.item.id),
          jobId: job.id,
          quantityRequiredForJob: bomComponent?.quantityRequiredForJob ?? 0,
          fromInventoryCosts: bomComponent?.unitCost.multiply(x.quantity.fromInventory, 2) ?? CostTaxBreakdown.ZERO,
          toInventoryCosts: bomComponent?.unitCost.multiply(x.quantity.toInventory, 2) ?? CostTaxBreakdown.ZERO,
          initialNote:
            notesByItemIdQuery.isLoading ? undefined
            : notesByItemIdQuery.error ? notesByItemIdQuery.error
            : (notesByItemIdQuery.data?.get(x.item.id) ?? null),
        };
      }),
    [existingInventory, bomComponentsByItemId, job.id, notesByItemIdQuery],
  );

  return (
    <TableWrapper className="col">
      <DataTable
        bordered
        hover
        data={data}
        columns={existingInventoryTableColumns}
        getRowId={({ rowId }) => rowId}
        initialState={{
          sorting: [
            { id: "item_type", desc: false },
            { id: "item_name", desc: false },
          ],
        }}
      />
    </TableWrapper>
  );
});
